import { HEADER_NODE_ID } from '../Constants';

export function getId() {
  return `${Date.now()}`;
}

function buildNestedNodes(nodes) {
  const map = new Map();
  const result = [];
  let headerIdItem = null;

  // Step 1: Create a map where each item is keyed by its id and identify the headerId
  nodes.forEach((item) => {
    map.set(item.id, { ...item, children: [] });
    if (item.id === 'headerId') {
      headerIdItem = map.get(item.id); // Save the item with id 'headerId'
    }
  });

  // Step 2: Loop through the array and handle each item
  nodes.forEach((item) => {
    if (!item.pId) {
      if (item.id === 'headerId') {
        // Add the header item to the root level
        result.push(headerIdItem);
      } else {
        // Add other root-level items normally
        headerIdItem.children.push(map.get(item.id));
      }
    } else {
      const parent = map.get(item.pId);
      if (parent) {
        parent.children.push(map.get(item.id)); // Add to parent's children
      }
    }
  });

  return result;
}

export function computeNodesAndEdges({ provisionRuleList }) {
  let nodes = [];

  // Add Header Node
  nodes.push({
    id: HEADER_NODE_ID
  });

  const listNodes = provisionRuleList.map((rule) => {
    return {
      id: rule.provisionRuleId,
      pId: rule?.parentRule?.provisionRuleId
    };
  });

  nodes = nodes.concat(listNodes);

  return {
    nodes: buildNestedNodes(nodes)
  };
}

export function excludedServiceCatalogItemIds(
  provisionRuleList,
  unProvisionedItems
) {
  const excludedItemIds: Array<string> = [];
  provisionRuleList.forEach((rule) => {
    rule.items.forEach((item) => {
      excludedItemIds.push(item.itemId);
    });
  });

  unProvisionedItems?.forEach((item) => {
    excludedItemIds.push(item.itemId);
  });

  return excludedItemIds;
}

export function deleteProvisionRuleAndItsDescendants(
  provisionRulesList,
  targetId
) {
  const childMap = provisionRulesList.reduce((map, rule) => {
    if (rule.parentRule) {
      const parentId = rule.parentRule.provisionRuleId;
      if (!map[parentId]) {
        map[parentId] = [];
      }
      map[parentId].push(rule.provisionRuleId);
    }
    return map;
  }, {});

  function getDescendantIds(ruleId) {
    const descendants = childMap[ruleId] || [];
    return descendants.reduce((acc, childId) => {
      acc.push(childId, ...getDescendantIds(childId));
      return acc;
    }, []);
  }

  // Get all descendants of the target rule
  const descendantsToDelete = getDescendantIds(targetId);

  // Include the target rule itself in the list of IDs to delete
  const idsToDelete = new Set([targetId, ...descendantsToDelete]);

  // Filter out rules that need to be deleted
  return provisionRulesList.filter(
    (rule) => !idsToDelete.has(rule.provisionRuleId)
  );
}
